import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './App';
import LoadBar from './LoadBar';
import loadApp from './loadApp';
import './alt';
import {LoadAction} from './actions';
import './css/App.css';
import Modal from './Modal';
import 'lazysizes';

if (process.env.NODE_ENV !== 'production') {
  const layout = document.getElementById('SS-Layout');
  const body = document.getElementsByTagName('body')[0];
  body.removeChild(layout);
}

ReactDOM.render(<LoadBar />, document.getElementById('loader'));
ReactDOM.render(<App />, document.getElementById('root'));
ReactDOM.render(<Modal />, document.getElementById('modal-root'));

loadApp()
  .then(() => {
    LoadAction.startApp.defer();
    return Promise.resolve();
  })
  .then(registerServiceWorker);



// WEBPACK FOOTER //
// ./src/index.js